import { Fragment, FormSubmit } from '../../../components'
import { FORMS } from '../../../constants'
import { andWhatNext, formValidation } from '../../../helpers'
import { useStyles } from './styles'
import { EmailEditor, Admin } from './index'
import { getSubmitProps } from './helpers'
import FormBase from '../../../components/FormBase'

const getFormErrors = () =>
  _.omit(
    _.mapValues(FORMS.emailMp.fields, () => null),
    ['body', 'subject']
  )

const EmailMp = ({ emailBody, rsv, fragments, postcode }) => {
  const classes = useStyles()
  const [cookies] = useCookies()
  const formRefs = _.mapValues(FORMS.emailMp.fields, () => React.useRef())

  const [submitted, setSubmitted] = useState(false)
  const [client, setClient] = useState()
  const [formErrors, setFormErrors] = useState(getFormErrors())
  const [saved, setSaved] = useState(true)
  const [formData, setFormData] = useState({
    ...FORMS.emailMp.fields,
    body: emailBody,
    subject: fragments['action_email_subject'].content,
    postcode,
  })

  useEffect(() => {
    const saved = cookies['neu_nclb_client']
    setClient(saved)
    setFormData({
      ...formData,
      ..._.mapValues(
        _.pick(saved, ['first_name', 'last_name', 'address', 'email']),
        (item) => _.replace(item, /\+/g, ' ')
      ),
    })
  }, [cookies])

  const updateForm = (prop, evt) => {
    setFormErrors(getFormErrors())
    setFormData({ ...formData, [prop]: evt.target.value })
  }

  const submitForm = async () => {
    await saveForm()
    const res = formValidation(formRefs, formErrors)
    if (res.valid) {
      setSubmitted(true)
    } else {
      setFormErrors(res.errors)
    }
  }

  const saveForm = async () => {
    await formRefs.body.current.save()
    setSaved(true)
  }

  if (submitted)
    return (
      <FormSubmit
        doSubmit={submitted}
        onSuccess={() =>
          (window.location.href = andWhatNext('emailMp', { postcode, post: true }))
        }
        {...getSubmitProps({ action: 'email', formData, token: client?.token })}
        thanks={`${formData['first_name']}, thank you!`}
      />
    )
  else
    return (
      <Grid item container {...rsv} className={classes.formContainer} component="form">
        <Grid item xs={12}>
          <Typography variant="h5" align="left" className={classes.sectionTitle}>
            How the email will look
          </Typography>
        </Grid>
        <EmailEditor {...{ formData, formRefs, setSaved, update: updateForm }} />
        <Admin fragments={fragments} />
        <FormBase
          {...{
            exclude: { phoneNumber: true, schoolRole: true, union: true },
            formData,
            formErrors,
            formRefs,
            onChange: updateForm,
            onSubmit: submitForm,
            padding: '24px 6px',
            preDisclaimer:
              'These details will be used to show your MP you are a constituent',
            buttonText: <Fragment title="email_mp_button" fragments={fragments} />,
          }}
        />
      </Grid>
    )
}

export default EmailMp
